module.exports = __webpack_public_path__ + "img/htw_campus_story.83c55c15.png";